import { useNavigate } from 'react-router-dom';
// styles
import { AuthWrapper, RestrictIcon, NotifyTitle, PrimaryButton, NextButton } from '../../styles';

// ----------------------------------------------------------------------

export default function RestrictPage() {
  const navigate  = useNavigate();

  return (
    <AuthWrapper>
      <RestrictIcon />
      <NotifyTitle>
        <p>접속 제한 안내</p>
        <span>
          비정상적인 로그인 시도(비밀번호 5회 오류)로 인해<br />
          회원님의 접속이 제한되었습니다.<br />
          접속 제한을 해제하시려면 본인 인증 후 비밀번호를 재설정해 주세요.
        </span>
      </NotifyTitle>

      <PrimaryButton onClick={() => navigate('/reset-password')} style={{'width': '100%'}}>비밀번호 재설정</PrimaryButton>

      <NextButton onClick={() => navigate('/', {state: { submit: true }})} style={{'marginTop': '20px'}}>메인으로<div /></NextButton>
    </AuthWrapper>
  );
}